import { render, staticRenderFns } from "./ApplicationSubmitSuccessComponent.vue?vue&type=template&id=6b9b26d4&scoped=true"
import script from "./ApplicationSubmitSuccessComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitSuccessComponent.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationSubmitSuccessComponent.vue?vue&type=style&index=0&id=6b9b26d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b26d4",
  null
  
)

export default component.exports